import {
  IJobValuesOverlayDistributionData,
  IJobValuesOverlayShewhartData,
} from './interface/job-values.ts';

const overlayLabel: Record<keyof (Omit<IJobValuesOverlayShewhartData, 'stdDev'> & IJobValuesOverlayDistributionData), string> = {
  lowerWarningLimit: '-2σ',
  lowerControlLimit: '-3σ',
  upperWarningLimit: '2σ',
  upperControlLimit: '3σ',
  average: 'Mittelwert',
  median: 'Median',
  q1: 'Q1',
  q3: 'Q3',
  upperBound: 'Statistisches Maximum',
  lowerBound: 'Statistisches Minimum',
  outlier: 'Ausreißer',
};

export default {
  overlayLabel,
};
